// extracted by mini-css-extract-plugin
export default {"ModalBody":"ModalBody_ModalBody__Qcw3g"};